import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RefundPolicy = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <button className="back-button" onClick={handleBack}>
          <ArrowLeft size={20} />
          Back to Home
        </button>
        
        <div className="privacy-policy-content">
          <h1>Refund and Cancellation Policy</h1>
          <p className="last-updated">Last updated: October 16, 2026</p>
          
          <section>
            <p>
              At <strong>JustLabs</strong> (operated by <strong>Pankaj Acharya</strong>), we strive to ensure customer satisfaction with our commercial software products. This Refund & Cancellation Policy applies specifically to purchases of our paid Android software product license, <strong>JustSolar</strong>, made directly through our website via our authorized secure payment gateway.
            </p>
          </section>

          <section>
            <h2>1. Order Cancellation</h2>
            <ul>
              <li>
                <strong>Prior to Activation Key Dispatch:</strong> You may cancel your order at any time before your unique JustSolar lifetime license key has been generated and dispatched to your email. To request cancellation, email <code>pankajacharyaorg@gmail.com</code> immediately with your Payment Transaction ID. A 100% full refund will be processed promptly.
              </li>
              <li>
                <strong>After Activation Key Dispatch:</strong> Once the unique lifetime license key and software access credentials have been provisioned and delivered to your email, cancellations are handled strictly in accordance with the Refund Eligibility criteria detailed below.
              </li>
            </ul>
          </section>

          <section>
            <h2>2. Refund Eligibility Criteria</h2>
            <p>
              We want you to invest in JustSolar with confidence. We offer a <strong>7-Day Technical Satisfaction Guarantee</strong> under the following conditions:
            </p>
            <ul>
              <li>
                <strong>Technical Incompatibility / Failure:</strong> If JustSolar experiences persistent technical bugs or is unable to run on your supported Android device (Android 9.0 or higher), and our engineering support team is unable to resolve the issue within 7 business days of your reported ticket.
              </li>
              <li>
                <strong>Duplicate Charges:</strong> In the rare event that you were charged more than once for the same license transaction due to a network or payment gateway error.
              </li>
              <li>
                <strong>Non-Delivery of License:</strong> If you did not receive your activation key or APK access within 48 hours of successful payment confirmation, and our support team failed to deliver it after being notified.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Non-Refundable Scenarios</h2>
            <p>Refunds cannot be granted under the following circumstances:</p>
            <ul>
              <li>Change of mind after the license key has been issued and successfully activated on an Android device.</li>
              <li>Purchases made on incompatible, rooted, or unauthorized custom ROM Android devices not meeting minimum specifications (minimum Android 9.0 required).</li>
              <li>Requests submitted after 7 days from the initial date of purchase.</li>
              <li>Purchases of other third-party services or Google Play Store apps (which are governed strictly by Google Play refund policies).</li>
            </ul>
          </section>

          <section>
            <h2>4. Refund Processing Time and Method</h2>
            <ul>
              <li>
                <strong>Method of Refund:</strong> Approved refunds are credited directly back to the <strong>original source of payment</strong> (Bank Account, UPI ID, or Credit/Debit Card) via our authorized payment gateway.
              </li>
              <li>
                <strong>Timeline:</strong> Once your refund request is approved by our team, the refund is initiated within <strong>24 to 48 hours</strong>. It typically takes <strong>5 to 7 business days</strong> for the funds to reflect in your bank account, depending on your financial institution's processing cycles.
              </li>
              <li>
                <strong>Deductions:</strong> We do not charge any restocking fee. The exact transaction amount paid will be returned to you.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. How to Initiate a Refund Request</h2>
            <p>To request a refund or cancellation, please follow these simple steps:</p>
            <ol>
              <li>Send an email to <code>pankajacharyaorg@gmail.com</code> with the subject line: <strong>"Refund Request - [Your Payment Transaction ID]"</strong>.</li>
              <li>Include your registered email address, full name, phone number, and a brief description of the issue encountered (along with device model and screenshot if technical).</li>
              <li>Our support team will review your request and respond within 24 business hours.</li>
            </ol>
          </section>

          <section>
            <h2>6. Contact & Merchant Identification</h2>
            <div className="contact-info">
              <p>For any questions regarding our Refund and Cancellation Policy, contact:</p>
              <p><strong>Merchant Legal Name:</strong> Pankaj Acharya</p>
              <p><strong>Business Brand:</strong> JustLabs</p>
              <p><strong>Support Email:</strong> <a href="mailto:pankajacharyaorg@gmail.com">pankajacharyaorg@gmail.com</a></p>
              <p><strong>Support Window:</strong> Monday – Saturday, 9:30 AM – 6:30 PM IST</p>
              <p><strong>Country of Operation:</strong> India</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
